<template>
  <div>
    <div class="d-none d-print-block">
      <div :id="lv1_info?.name + '_' + lv2_info?.name" class="sb-cover-print" :style="backgroundStyle">
        <div v-if="lv2_info && lang === 'KOR'">
          <h1 class="sb-cover-print-title fw-500 text-white mb-0">
            {{ lv2_info?.name }}
          </h1>
        </div>

        <div v-else-if="lv2_info">
          <h1 class="sb-cover-print-title fw-700 text-white mb-0">
            {{ lv2_info?.name_em ? lv2_info?.name_em : lv2_info?.name_ea }}
          </h1>
        </div>
      </div>
    </div>

    <div :class="['d-block d-print-none', { 'padded-container': !isStoryBoardToc }]">
      <div :class="isStoryBoardToc ? 'sb-cover-toc' : 'sb-cover'" :style="backgroundStyle">
        <div v-if="lv2_info && lang === 'KOR'">
          <h1 class="sb-cover-title fw-700 text-center text-white mb-0">
            {{ lv2_info?.name }}
          </h1>
        </div>

        <div v-else-if="lv2_info">
          <h1 class="sb-cover-title fw-700 text-center text-white mb-0">
            {{ lv2_info?.name_em ? lv2_info?.name_em : lv2_info?.name_ea }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Cover',
  props: {
    lv1_info: { type: Object, default: null },
    lv2_info: { type: Object, default: null },
  },
  data() {
    return {
      defaultImageUrl: 'https://sustainability.skecoplant.com/_nuxt/img/governace.fe5ba35.jpg',
    };
  },
  computed: {
    ...mapState('report_list', ['lang']),
    backgroundStyle() {
      if (!this.lv1_info) {
        return {
          backgroundImage: '',
          display: 'None',
        };
      }

      if (this.lv1_info?.cover_path) {
        return {
          backgroundImage:
            this.lv1_info.cover_path !== null
              ? `url(${this.$store.state.static_host + this.lv1_info.cover_path.replaceAll('\\', '/')})`
              : this.defaultImageUrl,
        };
      }
      else if (this.lv1_info?.cover_unsplash_path) {
        return {
          backgroundImage:
            this.lv1_info.cover_unsplash_path !== null
              ? `url(${this.lv1_info.cover_unsplash_path})`
              : `url(${this.defaultImageUrl})`,
        };
      }

      else { 
        return {
          backgroundColor: this.lv1_info?.background_color,
          backgroundImage: 'none',
        };

      }
    },
    isStoryBoardToc() {
      return this.$route.path === '/write_report/story_board_toc';
    },
  },
};
</script>

<style lang="scss" scoped>
.sb-cover {
  position: relative;
  height: calc(50vh - 90px);
  min-height: 200px;
  margin-top: 90px;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-size: cover;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &-title {
    font-size: 3.25rem;
    word-break: keep-all;

    @media (max-width: 1200px) {
      font-size: 3.1rem;
    }

    @media (max-width: 992px) {
      font-size: 2.95rem;
    }

    @media (max-width: 768px) {
      font-size: 2.8rem;
    }

    @media (max-width: 576px) {
      font-size: 2.65rem;
    }
  }
}

.sb-cover-print {
  position: relative;
  height: 30vh;
  min-height: 200px;
  max-height: 365px;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-size: cover;
  width: 100%;
  padding: 3rem;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;

  &-title {
    font-size: 3.25rem;
    line-height: 1;
    margin-bottom: 0;
    word-break: keep-all;
  }
}

.sb-cover-toc {
  position: relative;
  height: calc(40vh - 90px);
  min-height: 200px;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-size: cover;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &-title {
    font-size: 3rem;
    word-break: keep-all;

    @media (max-width: 1200px) {
      font-size: 2.8rem;
    }

    @media (max-width: 992px) {
      font-size: 2.6rem;
    }

    @media (max-width: 768px) {
      font-size: 2.4rem;
    }

    @media (max-width: 576px) {
      font-size: 2.2rem;
    }
  }
}
</style>
